import getTheme from "./getTheme";
export default function fontSize(index, theme) {
    let i = index;
    if (index < 0) {
        i = getTheme(theme).fontSize.length + index;
    }
    return getTheme(theme).fontSize[i] + "px";
}
//# sourceMappingURL=fontSize.js.map